import { formatInTimeZone } from "date-fns-tz";

export const toApiDateTime = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:00`;
};

export const formatDateTimeInTimezone = (date: Date, timeZone: string): string =>
  formatInTimeZone(date, timeZone, "yyyy-MM-dd HH:mm:00");

export const formatDateTimeForApi = (
  startTime: string,
  endTime: string
): { startDateTime: string; endDateTime: string } => {
  const startDate = new Date(startTime);
  const endDate = new Date(endTime);

  const startUTC = new Date(startDate.getTime() - startDate.getTimezoneOffset() * 60000);
  const endUTC = new Date(endDate.getTime() - endDate.getTimezoneOffset() * 60000);

  const formatUTC = (date: Date): string => {
    return date.toISOString().replace("T", " ").substring(0, 19);
  };

  return {
    startDateTime: formatUTC(startUTC),
    endDateTime: formatUTC(endUTC),
  };
};

export const formatTime = (date: Date): string => {
  return date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatDate = (date: Date): string => {
  return date.toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

export const getDuration = (start: Date, end: Date): number => {
  return Math.round((end.getTime() - start.getTime()) / 60000);
};

export const toLocalISOString = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  const milliseconds = String(date.getMilliseconds()).padStart(3, "0");

  const offset = -date.getTimezoneOffset();
  const offsetHours = String(Math.floor(Math.abs(offset) / 60)).padStart(2, "0");
  const offsetMinutes = String(Math.abs(offset) % 60).padStart(2, "0");
  const offsetSign = offset >= 0 ? "+" : "-";

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}${offsetSign}${offsetHours}:${offsetMinutes}`;
};
